import { OFFICIAL } from "./site";

// Complete list of 16 sacred deities worshipped in the Paramparapeetha
// of Sri Sode Vadiraja Matha. Each entry now includes Kannada translations
// (taglineKn, introKn, significanceKn) so the modal can render fully in Kannada.
export const DEITIES = [
  {
    slug: "bhuvaraha",
    name: "Sri Bhuvaraha",
    nameKn: "ಶ್ರೀ ಭೂವರಾಹ",
    sanskrit: "श्री भूवराह",
    tagline: "The presiding deity of the Parampara - blessed by Sri Madhvacharya himself",
    taglineKn: "ಪರಂಪರೆಯ ಪ್ರಧಾನ ದೇವರು - ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರಿಂದಲೇ ಅನುಗ್ರಹಿತರಾದವರು",
    image: OFFICIAL.bhuvaraha,
    isIdol: true,
    sizeClass: "max-h-[68%] max-w-[58%]",
    timing: "Presiding deity - worshipped daily",
    timingKn: "ಪ್ರಧಾನ ದೇವರು - ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Sri Madhvacharya blessed this Bhuvaraha icon to Sri Vishnu-tirtha, founder pontiff of Sri Sode Vadiraja Matha. The Bhuvaraha icon is a uniquely styled one where Lord Bhuvaraha rests on the hood of a lordly serpent with Bhudevi (form of goddess Lakshmi) sitting on the left thigh of the Lord. The Lord appears to be pleased and eager to grant merciful bliss to his consort.",
    introKn:
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಈ ಭೂವರಾಹ ಮೂರ್ತಿಯನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪ್ರಥಮ ಪೀಠಾಧಿಪತಿಗಳಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರಿಗೆ ಅನುಗ್ರಹಿಸಿದರು. ಈ ಮೂರ್ತಿಯು ವಿಶಿಷ್ಟ ರೂಪದ್ದಾಗಿದ್ದು - ಭಗವಾನ್ ಭೂವರಾಹನು ಶೇಷನಾಗನ ಹೆಡೆಯ ಮೇಲೆ ಆಸೀನನಾಗಿದ್ದಾನೆ ಹಾಗೂ ಎಡ ತೊಡೆಯ ಮೇಲೆ ಭೂದೇವಿ (ಲಕ್ಷ್ಮಿಯ ಸ್ವರೂಪ) ಆಸೀನಳಾಗಿದ್ದಾಳೆ. ಭಗವಂತನು ತನ್ನ ಪತ್ನಿಗೆ ಕರುಣಾಮಯಿ ಆನಂದವನ್ನು ಅನುಗ್ರಹಿಸಲು ಉತ್ಸಾಹದಿಂದ ಪ್ರಸನ್ನನಾಗಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತಾನೆ.",
    significance: "It is worshipped as the presiding and favourite deity of the Parampara.",
    significanceKn: "ಇದನ್ನು ಪರಂಪರೆಯ ಪ್ರಧಾನ ಹಾಗೂ ಪ್ರಿಯ ದೇವರೆಂದು ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
  },
  {
    slug: "hayagriva",
    name: "Sri Hayagriva",
    nameKn: "ಶ್ರೀ ಹಯಗ್ರೀವ",
    sanskrit: "श्री हयग्रीव",
    tagline: "Presiding deity of the Parampara - self-manifested to Sri Vadiraja",
    taglineKn: "ಪರಂಪರೆಯ ಪ್ರಧಾನ ದೇವರು - ಶ್ರೀ ವಾದಿರಾಜರಿಗೆ ಸ್ವಯಂ ಪ್ರಕಟಗೊಂಡವರು",
    image: OFFICIAL.hayagriva,
    isIdol: true,
    sizeClass: "max-h-[88%] max-w-[82%]",
    timing: "Presiding deity - daily Hayagriva Puja",
    timingKn: "ಪ್ರಧಾನ ದೇವರು - ದೈನಂದಿನ ಹಯಗ್ರೀವ ಪೂಜೆ",
    intro:
      "When a goldsmith tended to cast the metal into a mould to make the icon of Vighnesha, it casually turned into an icon of Hayagriva. He tried again and again but failed. He placed that icon at the corner as if unwanted. Then, the supreme Lord of Hayagriva form used to present in that voluntarily. It was nothing but an Archavatara of Hayagriva form. The Lord appeared in the dream of Vadiraja and asked him to take the icon for daily worship. He assured that he was doing Archavatara as promised. The Lord also instructed the goldsmith in a dream to offer that icon to the saint. Next day, Sri Vadiraja came to the abode of the goldsmith and saw that Hayagriva icon which was dazzling with the gracious and holy presence of the Lord. He took the icon and kept it on the Peetha with Bhuvaraha and worshipped with glorious adoration.",
    introKn:
      "ಒಬ್ಬ ಸ್ವರ್ಣಕಾರನು ವಿಘ್ನೇಶನ ಮೂರ್ತಿ ಮಾಡಲು ಲೋಹವನ್ನು ಅಚ್ಚಿನಲ್ಲಿ ಎರಕಹೊಯ್ದಾಗ, ಅದು ಹಯಗ್ರೀವ ಮೂರ್ತಿಯಾಗಿ ಪರಿವರ್ತನೆಗೊಂಡಿತು. ಅವನು ಪುನಃ ಪುನಃ ಪ್ರಯತ್ನಿಸಿದರೂ ವಿಫಲನಾದನು. ಆದ್ದರಿಂದ ಆ ಮೂರ್ತಿಯನ್ನು ಬೇಡವೆಂಬಂತೆ ಒಂದು ಮೂಲೆಯಲ್ಲಿ ಇಟ್ಟನು. ಆದರೆ ಪರಮಾತ್ಮನಾದ ಹಯಗ್ರೀವ ಸ್ವರೂಪದ ಭಗವಂತನು ಸ್ವಯಂಪ್ರೇರಿತನಾಗಿ ಅದರಲ್ಲಿ ಉಪಸ್ಥಿತನಾಗಲಾರಂಭಿಸಿದನು. ಅದು ಹಯಗ್ರೀವ ರೂಪದ ಅರ್ಚಾವತಾರವಾಗಿತ್ತು. ಭಗವಂತನು ಶ್ರೀ ವಾದಿರಾಜರ ಸ್ವಪ್ನದಲ್ಲಿ ಪ್ರತ್ಯಕ್ಷನಾಗಿ ಈ ಮೂರ್ತಿಯನ್ನು ದೈನಂದಿನ ಪೂಜೆಗಾಗಿ ಸ್ವೀಕರಿಸಬೇಕೆಂದು ಹೇಳಿದನು ಮತ್ತು ವಚನಬದ್ಧವಾಗಿ ಅರ್ಚಾವತಾರ ಮಾಡುತ್ತಿರುವುದಾಗಿ ಆಶ್ವಾಸನೆ ನೀಡಿದನು. ಭಗವಂತನು ಸ್ವರ್ಣಕಾರನ ಸ್ವಪ್ನದಲ್ಲಿ ಆ ಮೂರ್ತಿಯನ್ನು ಸಂತರಿಗೆ ಸಮರ್ಪಿಸುವಂತೆ ಸೂಚಿಸಿದನು. ಮರುದಿನ ಶ್ರೀ ವಾದಿರಾಜರು ಸ್ವರ್ಣಕಾರನ ಮನೆಗೆ ಬಂದು ಭಗವಂತನ ಕರುಣಾಮಯ ಉಪಸ್ಥಿತಿಯಿಂದ ಬೆಳಗುತ್ತಿದ್ದ ಆ ಹಯಗ್ರೀವ ಮೂರ್ತಿಯನ್ನು ದರ್ಶಿಸಿ, ಸ್ವೀಕರಿಸಿ, ಭೂವರಾಹನೊಂದಿಗೆ ಪೀಠದ ಮೇಲಿಟ್ಟು ಪೂಜಿಸಿದರು.",
    significance: "This is also a presiding deity of the Parampara.",
    significanceKn: "ಇವರೂ ಸಹ ಪರಂಪರೆಯ ಪ್ರಧಾನ ದೇವರಾಗಿದ್ದಾರೆ.",
  },
  {
    slug: "lakshmi-narasimha",
    name: "Sri Lakshmi Narasimha",
    nameKn: "ಶ್ರೀ ಲಕ್ಷ್ಮೀ ನೃಸಿಂಹ",
    sanskrit: "श्री लक्ष्मीनृसिंह",
    tagline: "The icon once worshipped by Bhimasena - recovered by Sri Vadiraja from Bhimakunda",
    taglineKn: "ಒಂದೊಮ್ಮೆ ಭೀಮಸೇನನಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟ ಮೂರ್ತಿ - ಶ್ರೀ ವಾದಿರಾಜರು ಭೀಮಕುಂಡದಿಂದ ಪಡೆದವರು",
    image: OFFICIAL.narasimha,
    isIdol: true,
    sizeClass: "max-h-[88%] max-w-[82%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "On pilgrimage, once Sri Vadiraja, with followers, was roaming about in the Kurukshetra land. He went to Bhimakunda (a pond), took out the club used by Bhimasena and showed it to others. He also took the Sri Lakshmi Narasimha icon duly worshipped by Bhimasena.",
    introKn:
      "ಒಂದು ತೀರ್ಥಯಾತ್ರೆಯಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರು ಶಿಷ್ಯರೊಂದಿಗೆ ಕುರುಕ್ಷೇತ್ರ ಭೂಮಿಯಲ್ಲಿ ಸಂಚರಿಸುತ್ತಿದ್ದರು. ಅವರು ಭೀಮಕುಂಡ (ಒಂದು ಸರೋವರ) ಎಂಬಲ್ಲಿಗೆ ಹೋಗಿ ಭೀಮಸೇನನು ಬಳಸಿದ ಗದೆಯನ್ನು ತೆಗೆದು ಇತರರಿಗೆ ತೋರಿಸಿದರು. ಜೊತೆಗೆ ಭೀಮಸೇನನಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟ ಶ್ರೀ ಲಕ್ಷ್ಮೀ ನೃಸಿಂಹ ಮೂರ್ತಿಯನ್ನೂ ಸಂಗ್ರಹಿಸಿ ತಂದರು.",
    significance:
      "Since then, that icon is being worshipped in the Parampara peetha by the pontiffs of Sri Sode Vadiraja Matha.",
    significanceKn:
      "ಅಂದಿನಿಂದ ಆ ಮೂರ್ತಿಯನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪೀಠಾಧಿಪತಿಗಳಿಂದ ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "vitthala",
    name: "Sri Vitthala",
    nameKn: "ಶ್ರೀ ವಿಠ್ಠಲ",
    sanskrit: "श्री विट्ठल",
    tagline: "Once adored by Brahma and Sage Gautama - retrieved by Sri Vadiraja from the Gautama Cave",
    taglineKn: "ಬ್ರಹ್ಮ ಹಾಗೂ ಗೌತಮ ಋಷಿಯಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟವರು - ಶ್ರೀ ವಾದಿರಾಜರು ಗೌತಮ ಗುಹೆಯಿಂದ ಪಡೆದವರು",
    image: OFFICIAL.vitthala,
    isIdol: true,
    sizeClass: "max-h-[88%] max-w-[82%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Once, Sri Vadiraja had been to the Gautama cave. It was the holy spot of penance of sage Gautama. He saw an icon of Vitthala originally adored by the four-faced Brahma. Brahma had blessed that icon to sage Gautama who was performing rigorous penance. Sage Gautama worshipped it to his full content and kept it in that cave.",
    introKn:
      "ಒಂದೊಮ್ಮೆ ಶ್ರೀ ವಾದಿರಾಜರು ಗೌತಮ ಗುಹೆಗೆ ಭೇಟಿ ನೀಡಿದರು. ಇದು ಗೌತಮ ಋಷಿಯ ತಪೋಭೂಮಿಯಾಗಿತ್ತು. ಅಲ್ಲಿ ಚತುರ್ಮುಖ ಬ್ರಹ್ಮನಿಂದ ಮೂಲತಃ ಪೂಜಿಸಲ್ಪಟ್ಟ ಒಂದು ವಿಠ್ಠಲ ಮೂರ್ತಿಯನ್ನು ಅವರು ದರ್ಶಿಸಿದರು. ಬ್ರಹ್ಮನು ಘೋರ ತಪಸ್ಸು ಮಾಡುತ್ತಿದ್ದ ಗೌತಮ ಋಷಿಗೆ ಆ ಮೂರ್ತಿಯನ್ನು ಅನುಗ್ರಹಿಸಿದ್ದನು. ಗೌತಮ ಋಷಿಯು ಪೂರ್ಣ ತೃಪ್ತಿಯಿಂದ ಅದನ್ನು ಪೂಜಿಸಿ ಆ ಗುಹೆಯಲ್ಲಿ ಇರಿಸಿದ್ದನು.",
    significance:
      "Sri Vadiraja collected that icon and used to worship it in the Paramparapeetha.",
    significanceKn:
      "ಶ್ರೀ ವಾದಿರಾಜರು ಆ ಮೂರ್ತಿಯನ್ನು ಸಂಗ್ರಹಿಸಿ ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸುತ್ತಿದ್ದರು.",
  },
  {
    slug: "kadugolu-krishna",
    name: "Kadugolu Sri Krishna",
    nameKn: "ಕಡುಗೋಲು ಶ್ರೀ ಕೃಷ್ಣ",
    sanskrit: "कडुगोलु श्रीकृष्ण",
    tagline: "Krishna with churning rod and rope - blessed by Sri Madhvacharya",
    taglineKn: "ಕಡುಗೋಲು ಹಾಗೂ ಹಗ್ಗ ಹಿಡಿದ ಕೃಷ್ಣ - ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರಿಂದ ಅನುಗ್ರಹಿತ",
    image: OFFICIAL.kadugoluKrishna,
    isIdol: true,
    sizeClass: "max-h-[82%] max-w-[72%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Sri Madhvacharya blessed different icons to a number of disciples consisting of pontiffs and householders. An icon of Krishna holding a churning rod and rope in his hands, and worshipped by Madhva, was given to Sri Vadiraja Matha at the time of Vrindavanacharya (1774-1865) by the descendants of the householder concerned.",
    introKn:
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೀಠಾಧಿಪತಿಗಳಿಗೂ ಗೃಹಸ್ಥ ಶಿಷ್ಯರಿಗೂ ವಿವಿಧ ಮೂರ್ತಿಗಳನ್ನು ಅನುಗ್ರಹಿಸಿದ್ದರು. ಕೈಗಳಲ್ಲಿ ಕಡುಗೋಲು ಮತ್ತು ಹಗ್ಗ ಹಿಡಿದ ಈ ಕೃಷ್ಣನ ಮೂರ್ತಿಯನ್ನು ಮಧ್ವರೇ ಪೂಜಿಸಿದ್ದರು. ಶ್ರೀ ವೃಂದಾವನಾಚಾರ್ಯರ ಕಾಲದಲ್ಲಿ (೧೭೭೪-೧೮೬೫) ಆ ಗೃಹಸ್ಥ ಕುಟುಂಬದ ವಂಶಜರು ಈ ಮೂರ್ತಿಯನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠಕ್ಕೆ ಸಮರ್ಪಿಸಿದರು.",
    significance: "Since then, it is being worshipped in the Paramparapeetha.",
    significanceKn: "ಅಂದಿನಿಂದ ಇದನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "garudavahana-lakshminarayana",
    name: "Garudavahana Sri Lakshmi Narayana",
    nameKn: "ಗರುಡವಾಹನ ಶ್ರೀ ಲಕ್ಷ್ಮೀ ನಾರಾಯಣ",
    sanskrit: "गरुडवाहन श्रीलक्ष्मीनारायण",
    tagline: "Narayana with Lakshmi seated on Garuda - worshipped with the Balamuri conch",
    taglineKn: "ಗರುಡನ ಮೇಲೆ ಲಕ್ಷ್ಮಿಯೊಂದಿಗೆ ವಿರಾಜಿಸುವ ನಾರಾಯಣ - ಬಲಮುರಿ ಶಂಖದೊಂದಿಗೆ ಪೂಜೆ",
    image: OFFICIAL.garudavahana,
    isIdol: true,
    sizeClass: "max-h-[85%] max-w-[75%]",
    timing: "Daily worship with Balamuri Shankha",
    timingKn: "ಬಲಮುರಿ ಶಂಖದೊಂದಿಗೆ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "This icon was also worshipped by Sri Madhvacharya. Lord Narayana with his consort goddess Lakshmi is seated on his vehicle god Garuda.",
    introKn:
      "ಈ ಮೂರ್ತಿಯನ್ನೂ ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೂಜಿಸಿದ್ದರು. ತನ್ನ ಪತ್ನಿ ಲಕ್ಷ್ಮಿಯೊಂದಿಗೆ ಭಗವಾನ್ ನಾರಾಯಣನು ವಾಹನ ದೇವತೆ ಗರುಡನ ಮೇಲೆ ಆಸೀನನಾಗಿದ್ದಾನೆ.",
    significance: "It is worshipped daily with the Balamuri conch.",
    significanceKn: "ಇದನ್ನು ಬಲಮುರಿ ಶಂಖದೊಂದಿಗೆ ದೈನಂದಿನ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
  },
  {
    slug: "rama-vitthala",
    name: "Sri Rama & Sri Vitthala",
    nameKn: "ಶ್ರೀ ರಾಮ ಹಾಗೂ ಶ್ರೀ ವಿಠ್ಠಲ",
    sanskrit: "श्रीराम एवं श्रीविट्ठल",
    tagline: "Once adored by Vali and Sugriva - unearthed by Sri Vadiraja at Vijayanagara",
    taglineKn: "ವಾಲಿ ಹಾಗೂ ಸುಗ್ರೀವರಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟವರು - ಶ್ರೀ ವಾದಿರಾಜರು ವಿಜಯನಗರದಲ್ಲಿ ಉದ್ಧರಿಸಿದವರು",
    image: OFFICIAL.ramaVitthala,
    isIdol: true,
    sizeClass: "max-h-[86%] max-w-[85%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Once, Vali and Sugriva did penance and propitiated god Brahma. Pleased with the penance, Brahma blessed them with the icons of Sri Rama and Sri Vitthala. Both Vali and Sugriva worshipped those icons with special adoration. At the end of Tretayuga, the icons were kept underground with abundant treasure. In this age, Sri Vadiraja - with his intuitive knowledge - knew of all this. Around 1527 A.D., when the Vijayanagara dynasty was facing a financial crisis, Sri Vadiraja went to Vijayanagara and unearthed the abundant treasure and gave it to Krishnadevaraya and Achyutadevaraya. He took those two icons of Rama and Vitthala and worshipped them daily.",
    introKn:
      "ಒಂದೊಮ್ಮೆ ವಾಲಿ ಮತ್ತು ಸುಗ್ರೀವರು ತಪಸ್ಸು ಮಾಡಿ ಬ್ರಹ್ಮನನ್ನು ಪ್ರಸನ್ನಗೊಳಿಸಿದರು. ತೃಪ್ತನಾದ ಬ್ರಹ್ಮನು ಅವರಿಗೆ ಶ್ರೀ ರಾಮ ಮತ್ತು ಶ್ರೀ ವಿಠ್ಠಲ ಮೂರ್ತಿಗಳನ್ನು ಅನುಗ್ರಹಿಸಿದನು. ವಾಲಿ ಹಾಗೂ ಸುಗ್ರೀವರು ಇಬ್ಬರೂ ಆ ಮೂರ್ತಿಗಳನ್ನು ವಿಶೇಷ ಶ್ರದ್ಧೆಯಿಂದ ಪೂಜಿಸಿದರು. ತ್ರೇತಾಯುಗದ ಕೊನೆಯಲ್ಲಿ ಆ ಮೂರ್ತಿಗಳನ್ನು ಅಪಾರ ಸಂಪತ್ತಿನೊಂದಿಗೆ ಭೂಗತಗೊಳಿಸಲಾಯಿತು. ಈ ಯುಗದಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರು ತಮ್ಮ ಅಂತಃಪ್ರಜ್ಞೆಯಿಂದ ಇವೆಲ್ಲವನ್ನೂ ತಿಳಿದಿದ್ದರು. ಸುಮಾರು ಕ್ರಿ.ಶ. ೧೫೨೭ರಲ್ಲಿ ವಿಜಯನಗರ ಸಾಮ್ರಾಜ್ಯವು ಆರ್ಥಿಕ ಸಂಕಷ್ಟದಲ್ಲಿದ್ದಾಗ, ಶ್ರೀ ವಾದಿರಾಜರು ವಿಜಯನಗರಕ್ಕೆ ತೆರಳಿ ಅಪಾರ ಸಂಪತ್ತನ್ನು ಉದ್ಧರಿಸಿ ಕೃಷ್ಣದೇವರಾಯ ಮತ್ತು ಅಚ್ಯುತದೇವರಾಯರಿಗೆ ನೀಡಿದರು. ಆ ರಾಮ ಮತ್ತು ವಿಠ್ಠಲ ಮೂರ್ತಿಗಳನ್ನು ತಾವು ತೆಗೆದುಕೊಂಡು ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸಿದರು.",
    significance:
      "The icon of Rama appears to be made of silver, with Sudarshana on the crest and feet.",
    significanceKn:
      "ರಾಮನ ಮೂರ್ತಿಯು ಬೆಳ್ಳಿಯಿಂದ ಮಾಡಿದಂತಿದ್ದು, ಶಿರ ಮತ್ತು ಪಾದಗಳಲ್ಲಿ ಸುದರ್ಶನ ಚಿಹ್ನೆಯಿದೆ.",
  },
  {
    slug: "srinivasa-sridevi-bhudevi",
    name: "Lord Srinivasa with Sridevi and Bhudevi",
    nameKn: "ಶ್ರೀ ಶ್ರೀದೇವಿ ಭೂದೇವಿ ಸಮೇತ ಶ್ರೀನಿವಾಸ",
    sanskrit: "श्रीनिवास श्रीभूसमेत",
    tagline: "Blessed by Lord Venkateshwara at Tirumala - with the sacred Saligrama garland",
    taglineKn: "ತಿರುಮಲದಲ್ಲಿ ಭಗವಾನ್ ವೇಂಕಟೇಶ್ವರರಿಂದ ಅನುಗ್ರಹಿತ - ಪವಿತ್ರ ಸಾಲಿಗ್ರಾಮ ಮಾಲೆಯೊಂದಿಗೆ",
    image: OFFICIAL.srinivasa,
    isIdol: true,
    sizeClass: "max-h-[86%] max-w-[85%]",
    timing: "Suprabhata & daily worship",
    timingKn: "ಸುಪ್ರಭಾತ ಹಾಗೂ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Once, Sri Vadiraja wished to have the darshana of Lord Venkateshwara. When he came to Tirupati, he saw the rocks of the steps appearing as Saligrama and felt uneasy to tread on them. So, he climbed the hill on his knees, singing the glory of the Lord. Sri Vadiraja worshipped that presiding deity to his entire satisfaction and offered him a garland of one hundred and eight Saligramas. That Saligrama garland adorns the Lord even today. The Lord, being very much pleased, blessed Sri Vadiraja with his icon along with Sri and Bhu. The gracious presence of Lord Srinivasa with Sri and Bhu in those icons is complete.",
    introKn:
      "ಒಂದೊಮ್ಮೆ ಶ್ರೀ ವಾದಿರಾಜರು ಭಗವಾನ್ ವೇಂಕಟೇಶ್ವರರ ದರ್ಶನ ಬಯಸಿ ತಿರುಪತಿಗೆ ಬಂದರು. ಮೆಟ್ಟಿಲುಗಳ ಕಲ್ಲುಗಳು ಸಾಲಿಗ್ರಾಮಗಳಂತೆ ಕಂಡು, ಅವುಗಳ ಮೇಲೆ ನಡೆಯಲು ಸಂಕೋಚಗೊಂಡರು. ಆದ್ದರಿಂದ ಭಗವಂತನ ಮಹಿಮೆಯನ್ನು ಹಾಡುತ್ತಾ ಮೊಣಕಾಲಿನ ಮೇಲೆ ಬೆಟ್ಟವನ್ನೇರಿದರು. ಶ್ರೀ ವಾದಿರಾಜರು ಆ ದೇವರನ್ನು ಪೂರ್ಣ ತೃಪ್ತಿಯಿಂದ ಪೂಜಿಸಿ, ನೂರೆಂಟು ಸಾಲಿಗ್ರಾಮಗಳ ಮಾಲೆಯನ್ನು ಸಮರ್ಪಿಸಿದರು. ಆ ಸಾಲಿಗ್ರಾಮ ಮಾಲೆ ಇಂದಿಗೂ ಭಗವಂತನನ್ನು ಅಲಂಕರಿಸುತ್ತಿದೆ. ಪರಮ ಪ್ರಸನ್ನನಾದ ಭಗವಂತನು ಶ್ರೀ ಮತ್ತು ಭೂ ಸಮೇತ ತನ್ನ ಮೂರ್ತಿಗಳಿಂದ ವಾದಿರಾಜರನ್ನು ಅನುಗ್ರಹಿಸಿದನು.",
    significance:
      "Since then, those icons have been worshipped in the Paramparapeetha of Sri Sode Vadiraja Matha.",
    significanceKn:
      "ಅಂದಿನಿಂದ ಆ ಮೂರ್ತಿಗಳನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "pacche-vitthala",
    name: "Pacche Vitthala",
    nameKn: "ಪಚ್ಚೆ ವಿಠ್ಠಲ",
    sanskrit: "पच्चे विट्ठल",
    tagline: "The emerald Vitthala - transformed from a Jaina icon by the meditation of Sri Vadiraja",
    taglineKn: "ಪಚ್ಚೆ ವಿಠ್ಠಲ - ಶ್ರೀ ವಾದಿರಾಜರ ಧ್ಯಾನದಿಂದ ಜೈನ ಮೂರ್ತಿಯಿಂದ ಪರಿವರ್ತಿತ",
    image: OFFICIAL.paccheVitthala,
    isIdol: true,
    sizeClass: "max-h-[85%] max-w-[70%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Once, Sri Vadiraja was moving across Mudabidare. The king of that region invited him with pure devotion to the Jaina temple. Seeing the faith and regard of the king, Sri Vadiraja accepted the invitation. He, while entering the temple, was deeply meditating on the Vitthala form of the Lord. By virtue of that, the Suddha Jina icon got altered into the Vitthala form. Sri Vadiraja took that icon of emerald and used to worship it daily.",
    introKn:
      "ಒಂದೊಮ್ಮೆ ಶ್ರೀ ವಾದಿರಾಜರು ಮೂಡಬಿದಿರೆಯ ಮೂಲಕ ಹಾದುಹೋಗುತ್ತಿದ್ದರು. ಆ ಪ್ರದೇಶದ ರಾಜನು ಶುದ್ಧ ಭಕ್ತಿಯಿಂದ ಅವರನ್ನು ಜೈನ ದೇವಾಲಯಕ್ಕೆ ಆಹ್ವಾನಿಸಿದನು. ರಾಜನ ಶ್ರದ್ಧೆ ಮತ್ತು ಗೌರವವನ್ನು ಕಂಡು ಶ್ರೀ ವಾದಿರಾಜರು ಆಹ್ವಾನವನ್ನು ಸ್ವೀಕರಿಸಿದರು. ದೇವಾಲಯ ಪ್ರವೇಶಿಸುವಾಗ ಅವರು ಭಗವಂತನ ವಿಠ್ಠಲ ರೂಪವನ್ನೇ ಗಾಢವಾಗಿ ಧ್ಯಾನಿಸುತ್ತಿದ್ದರು. ಅದರ ಪ್ರಭಾವದಿಂದ ಶುದ್ಧ ಜಿನ ಮೂರ್ತಿಯು ವಿಠ್ಠಲ ರೂಪಕ್ಕೆ ಪರಿವರ್ತನೆಗೊಂಡಿತು. ಶ್ರೀ ವಾದಿರಾಜರು ಆ ಪಚ್ಚೆಯ ಮೂರ್ತಿಯನ್ನು ಸ್ವೀಕರಿಸಿ ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸಿದರು.",
    significance: "It is worshipped in the Paramparapeetha even to this day.",
    significanceKn: "ಇಂದಿಗೂ ಇದನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "hayagriva-vishnutirtha",
    name: "Sri Hayagriva (of Sri Vishnutirtha)",
    nameKn: "ಶ್ರೀ ಹಯಗ್ರೀವ (ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರದ್ದು)",
    sanskrit: "श्री हयग्रीव",
    tagline: "Received from Sri Vishnutirtha at Harishchandra Mountain",
    taglineKn: "ಹರಿಶ್ಚಂದ್ರ ಪರ್ವತದಲ್ಲಿ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರಿಂದ ಪ್ರಾಪ್ತಿ",
    image: OFFICIAL.hayagriva2,
    isIdol: true,
    sizeClass: "max-h-[88%] max-w-[80%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Sri Vishnutirtha, brother of Sri Madhvacharya, was having an icon of Hayagriva for special adoration. When Sri Vadiraja went to Harishchandra mountain and met Sri Vishnutirtha in person, he was given that Hayagriva icon as a witness of their meeting.",
    introKn:
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರ ಸಹೋದರರಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರು ವಿಶೇಷ ಪೂಜೆಗಾಗಿ ಒಂದು ಹಯಗ್ರೀವ ಮೂರ್ತಿಯನ್ನು ಇರಿಸಿಕೊಂಡಿದ್ದರು. ಶ್ರೀ ವಾದಿರಾಜರು ಹರಿಶ್ಚಂದ್ರ ಪರ್ವತಕ್ಕೆ ತೆರಳಿ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರನ್ನು ಸಾಕ್ಷಾತ್ ಭೇಟಿಯಾದಾಗ, ಆ ಭೇಟಿಯ ಸಾಕ್ಷಿಯಾಗಿ ಆ ಹಯಗ್ರೀವ ಮೂರ್ತಿಯನ್ನು ಅವರಿಗೆ ನೀಡಲಾಯಿತು.",
    significance: "Since then, that Pratima is being worshipped in the Paramparapeetha daily.",
    significanceKn: "ಅಂದಿನಿಂದ ಆ ಪ್ರತಿಮೆಯನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "vyasamushti",
    name: "Sri Vyasamushti",
    nameKn: "ಶ್ರೀ ವ್ಯಾಸಮುಷ್ಟಿ",
    sanskrit: "श्री व्यासमुष्टि",
    tagline: "One of the eight Saligramas gifted to Sri Madhvacharya at Urdhvabadari",
    taglineKn: "ಉರ್ಧ್ವಬದರಿಯಲ್ಲಿ ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರಿಗೆ ದೊರೆತ ಎಂಟು ಸಾಲಿಗ್ರಾಮಗಳಲ್ಲೊಂದು",
    image: OFFICIAL.vyasamushti,
    isIdol: true,
    sizeClass: "max-h-[78%] max-w-[80%]",
    timing: "Adored during daily worship",
    timingKn: "ದೈನಂದಿನ ಪೂಜೆಯಲ್ಲಿ ವಿಶೇಷ ಆರಾಧನೆ",
    intro:
      "When Sri Madhvacharya visited Urdhvabadari, he was given eight Vyasamushtis. Sri Madhvacharya kept one Vyasamushti Saligrama in the Madhyavatamatha and worshipped it. The saint pontiffs of the eight Mathas used to worship that Vyasamushti at their convenience. When that Vyasamushti was brought back and kept in Madhyavatamatha by Sri Vadiraja, that Matha came under the possession of Sode Vadirajamatha. It was Vrindavanacharya who, at the hinted instruction in Vrindavanakhyana, kept that in between the Hayagriva and Bhuvaraha icons in Paramparapeetha and worshipped it as instructed. He then brought that Saligrama to the Krishnasannidhi and performed Samanadhikaranapuja.",
    introKn:
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಉರ್ಧ್ವಬದರಿಗೆ ಭೇಟಿ ನೀಡಿದಾಗ ಅವರಿಗೆ ಎಂಟು ವ್ಯಾಸಮುಷ್ಟಿಗಳು ದೊರೆತವು. ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಒಂದು ವ್ಯಾಸಮುಷ್ಟಿ ಸಾಲಿಗ್ರಾಮವನ್ನು ಮಧ್ಯಾವತ ಮಠದಲ್ಲಿ ಇರಿಸಿ ಪೂಜಿಸಿದರು. ಎಂಟು ಮಠಗಳ ಪೀಠಾಧಿಪತಿಗಳು ತಮ್ಮ ಅನುಕೂಲಕ್ಕೆ ತಕ್ಕಂತೆ ಆ ವ್ಯಾಸಮುಷ್ಟಿಯನ್ನು ಪೂಜಿಸುತ್ತಿದ್ದರು. ಶ್ರೀ ವಾದಿರಾಜರು ಆ ವ್ಯಾಸಮುಷ್ಟಿಯನ್ನು ಮತ್ತೆ ಮಧ್ಯಾವತ ಮಠಕ್ಕೆ ತಂದಿಟ್ಟಾಗ, ಆ ಮಠವು ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಸ್ವಾಧೀನಕ್ಕೆ ಬಂತು. ವೃಂದಾವನಾಚಾರ್ಯರು ವೃಂದಾವನಾಖ್ಯಾನದ ಸೂಚನೆಯಂತೆ ಇದನ್ನು ಪರಂಪರಾ ಪೀಠದ ಹಯಗ್ರೀವ ಮತ್ತು ಭೂವರಾಹ ಮೂರ್ತಿಗಳ ನಡುವೆ ಇರಿಸಿ ಪೂಜಿಸಿದರು ಮತ್ತು ನಂತರ ಕೃಷ್ಣ ಸನ್ನಿಧಿಗೆ ತಂದು ಸಮಾನಾಧಿಕರಣ ಪೂಜೆಯನ್ನು ನೆರವೇರಿಸಿದರು.",
    significance:
      "The Vyasamushti is accorded special adoration at the time of daily worship.",
    significanceKn:
      "ದೈನಂದಿನ ಪೂಜೆಯ ವೇಳೆ ವ್ಯಾಸಮುಷ್ಟಿಗೆ ವಿಶೇಷ ಆರಾಧನೆಯನ್ನು ಸಲ್ಲಿಸಲಾಗುತ್ತದೆ.",
  },
  {
    slug: "paryaya-krishna",
    name: "Paryaya Sri Krishna",
    nameKn: "ಪರ್ಯಾಯ ಶ್ರೀ ಕೃಷ್ಣ",
    sanskrit: "पर्याय श्रीकृष्ण",
    tagline: "The small Krishna icon of Sri Vadiraja's fifth Paryaya at Sode",
    taglineKn: "ಸೋದೆಯಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರ ಐದನೆಯ ಪರ್ಯಾಯದ ಸಣ್ಣ ಕೃಷ್ಣ ಮೂರ್ತಿ",
    image: OFFICIAL.paryayaKrishna,
    isIdol: true,
    sizeClass: "max-h-[80%] max-w-[68%]",
    timing: "Daily worship in the Paramparapeetha",
    timingKn: "ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "Sri Vadiraja granted the performance of the fifth Paryaya to his disciple Sri Vedavedyatirtha and came to Sode. There, at the holy Sannidhana of Venugopala Krishna, he did his Paryaya similar to that of Krishnaparyaya at Udupi. For special offerings and adoration, Sri Vadiraja used to have a small icon of Lord Krishna.",
    introKn:
      "ಶ್ರೀ ವಾದಿರಾಜರು ಐದನೆಯ ಪರ್ಯಾಯದ ನಿರ್ವಹಣೆಯನ್ನು ತಮ್ಮ ಶಿಷ್ಯರಾದ ಶ್ರೀ ವೇದವೇದ್ಯತೀರ್ಥರಿಗೆ ಅನುಗ್ರಹಿಸಿ ಸೋದೆಗೆ ಬಂದರು. ಅಲ್ಲಿ ವೇಣುಗೋಪಾಲ ಕೃಷ್ಣನ ಪವಿತ್ರ ಸನ್ನಿಧಾನದಲ್ಲಿ ಉಡುಪಿಯ ಕೃಷ್ಣ ಪರ್ಯಾಯದಂತೆಯೇ ಪರ್ಯಾಯವನ್ನು ನಡೆಸಿದರು. ವಿಶೇಷ ನೈವೇದ್ಯ ಮತ್ತು ಆರಾಧನೆಗಾಗಿ ಶ್ರೀ ವಾದಿರಾಜರು ಒಂದು ಸಣ್ಣ ಕೃಷ್ಣನ ಮೂರ್ತಿಯನ್ನು ಇರಿಸಿಕೊಂಡಿದ್ದರು.",
    significance:
      "After the Paryaya, that icon is being worshipped daily by the pontiffs of Sri Sode Vadiraja Matha in the Paramparapeetha.",
    significanceKn:
      "ಪರ್ಯಾಯದ ನಂತರ ಆ ಮೂರ್ತಿಯನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪೀಠಾಧಿಪತಿಗಳು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸುತ್ತಿದ್ದಾರೆ.",
  },
  {
    slug: "srimushnavaraha",
    name: "Srimushnavaraha",
    nameKn: "ಶ್ರೀಮುಷ್ಣ ವರಾಹ",
    sanskrit: "श्रीमुष्णवराह",
    tagline: "Small form of Varaha received at the holy centre of Srimushna",
    taglineKn: "ಶ್ರೀಮುಷ್ಣ ಎಂಬ ಪವಿತ್ರ ಕ್ಷೇತ್ರದಲ್ಲಿ ಪ್ರಾಪ್ತಿಯಾದ ವರಾಹನ ಸಣ್ಣ ಸ್ವರೂಪ",
    image: OFFICIAL.srimushnavaraha,
    isIdol: true,
    sizeClass: "max-h-[85%] max-w-[70%]",
    timing: "Daily worship with special adoration",
    timingKn: "ವಿಶೇಷ ಆರಾಧನೆಯೊಂದಿಗೆ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "When Sri Vadiraja went to the holy centre of Srimushna, he worshipped Lord Varaha with due adoration and devotion. As a result, Lord Varaha, being immensely pleased, favoured Sri Vadiraja with a gracious blessing by appearing in a small form of icon.",
    introKn:
      "ಶ್ರೀ ವಾದಿರಾಜರು ಶ್ರೀಮುಷ್ಣ ಎಂಬ ಪವಿತ್ರ ಕ್ಷೇತ್ರಕ್ಕೆ ತೆರಳಿ ಭಗವಾನ್ ವರಾಹನನ್ನು ಶ್ರದ್ಧಾ ಭಕ್ತಿಯಿಂದ ಪೂಜಿಸಿದರು. ಇದರ ಫಲವಾಗಿ, ಪರಮ ಪ್ರಸನ್ನನಾದ ಭಗವಾನ್ ವರಾಹನು ಒಂದು ಸಣ್ಣ ಮೂರ್ತಿ ರೂಪದಲ್ಲಿ ಪ್ರಕಟಗೊಂಡು ಶ್ರೀ ವಾದಿರಾಜರನ್ನು ಕರುಣಾ ಅನುಗ್ರಹಿಸಿದನು.",
    significance:
      "That icon of Varaha is worshipped in the Sode Matha with special adoration.",
    significanceKn:
      "ವರಾಹನ ಆ ಮೂರ್ತಿಯನ್ನು ಸೋದೆ ಮಠದಲ್ಲಿ ವಿಶೇಷ ಆರಾಧನೆಯಿಂದ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
  },
  {
    slug: "vishvambhara-saligrama",
    name: "Sri Vishvambhara Saligrama",
    nameKn: "ಶ್ರೀ ವಿಶ್ವಂಭರ ಸಾಲಿಗ್ರಾಮ",
    sanskrit: "श्री विश्वम्भर शालिग्राम",
    tagline: "Found in the Gautama cave alongside the Vitthala icon",
    taglineKn: "ವಿಠ್ಠಲ ಮೂರ್ತಿಯೊಂದಿಗೆ ಗೌತಮ ಗುಹೆಯಲ್ಲಿ ಪ್ರಾಪ್ತಿ",
    image: OFFICIAL.vishvambhara,
    isIdol: true,
    sizeClass: "max-h-[75%] max-w-[80%]",
    timing: "Worshipped daily on the Samsthanapeetha",
    timingKn: "ಸಂಸ್ಥಾನ ಪೀಠದಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "This sacred Saligrama was found in the Gautama cave. Sri Vadiraja brought it along with the Vitthala icon and, keeping it on the Samsthanapeetha, worshipped it daily.",
    introKn:
      "ಈ ಪವಿತ್ರ ಸಾಲಿಗ್ರಾಮವು ಗೌತಮ ಗುಹೆಯಲ್ಲಿ ದೊರೆಯಿತು. ಶ್ರೀ ವಾದಿರಾಜರು ಇದನ್ನು ವಿಠ್ಠಲ ಮೂರ್ತಿಯೊಂದಿಗೆ ತಂದು, ಸಂಸ್ಥಾನ ಪೀಠದಲ್ಲಿ ಇರಿಸಿ ಪ್ರತಿನಿತ್ಯ ಪೂಜಿಸಿದರು.",
    significance:
      "It remains an essential presence within the daily worship of the Matha.",
    significanceKn:
      "ಇದು ಮಠದ ದೈನಂದಿನ ಪೂಜೆಯಲ್ಲಿ ಅಗತ್ಯವಾದ ಸಾನ್ನಿಧ್ಯವಾಗಿ ಉಳಿದಿದೆ.",
  },
  {
    slug: "mukhyaprana-vadiraja",
    name: "Sri Mukhyaprana and Sri Vadirajaru",
    nameKn: "ಶ್ರೀ ಮುಖ್ಯಪ್ರಾಣ ಹಾಗೂ ಶ್ರೀ ವಾದಿರಾಜರು",
    sanskrit: "श्री मुख्यप्राण एवं श्री वादिराज",
    tagline: "The Lataavya Ruju god worshipped alongside his disciple - signifying Samatva",
    taglineKn: "ಸಮತ್ವವನ್ನು ಸೂಚಿಸುತ್ತಾ ತಮ್ಮ ಶಿಷ್ಯರೊಂದಿಗೆ ಪೂಜಿಸಲ್ಪಡುವ ಲಾತವ್ಯ ಋಜು ದೇವತೆ",
    image: OFFICIAL.mukhyapranaVadiraja,
    isIdol: true,
    sizeClass: "max-h-[86%] max-w-[82%]",
    timing: "Daily worship in single plate",
    timingKn: "ಒಂದೇ ತಟ್ಟೆಯಲ್ಲಿ ದೈನಂದಿನ ಪೂಜೆ",
    intro:
      "The icons of Sri Mukhyaprana and Sri Vadirajaru are worshipped kept in a single plate. The icon of Vadiraja was prepared by Sri Vadiraja himself and it was given to his mother at the time of setting out for pilgrimage. It virtually avoided the feeling of separation of Vadiraja in physical absence. Since Sri Vadiraja is Latavya Ruju god, he is worshipped with Mukhyaprana. This mode of worship signifies the aspect of Samatva.",
    introKn:
      "ಶ್ರೀ ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ಶ್ರೀ ವಾದಿರಾಜರ ಮೂರ್ತಿಗಳನ್ನು ಒಂದೇ ತಟ್ಟೆಯಲ್ಲಿ ಇರಿಸಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ವಾದಿರಾಜರ ಮೂರ್ತಿಯನ್ನು ಶ್ರೀ ವಾದಿರಾಜರೇ ಸ್ವತಃ ತಯಾರಿಸಿ, ತೀರ್ಥಯಾತ್ರೆಗೆ ಹೊರಡುವಾಗ ತಮ್ಮ ತಾಯಿಗೆ ಸಮರ್ಪಿಸಿದ್ದರು. ಇದು ಭೌತಿಕ ಅನುಪಸ್ಥಿತಿಯಲ್ಲಿ ವಾದಿರಾಜರ ವಿಯೋಗ ಭಾವನೆಯನ್ನು ನಿವಾರಿಸಿತು. ಶ್ರೀ ವಾದಿರಾಜರು ಲಾತವ್ಯ ಋಜು ದೇವತೆಯಾದ್ದರಿಂದ ಅವರನ್ನು ಮುಖ್ಯಪ್ರಾಣನೊಂದಿಗೆ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ಈ ಪೂಜಾ ವಿಧಾನವು ಸಮತ್ವ ತತ್ವವನ್ನು ಸೂಚಿಸುತ್ತದೆ.",
    significance:
      "The pose of the icon ascertains the fact that like Mukhyaprana, Sri Vadiraja is also the prime support to the world of Garuda, Shesha and others.",
    significanceKn:
      "ಮುಖ್ಯಪ್ರಾಣನಂತೆಯೇ ಶ್ರೀ ವಾದಿರಾಜರೂ ಗರುಡ, ಶೇಷ ಮತ್ತಿತರರ ಜಗತ್ತಿಗೆ ಪ್ರಧಾನ ಆಧಾರವೆಂಬುದನ್ನು ಮೂರ್ತಿಯ ಭಂಗಿಯು ದೃಢಪಡಿಸುತ್ತದೆ.",
  },
  {
    slug: "suvarnapaduka",
    name: "Suvarnapaduka of Sri Vadirajaru",
    nameKn: "ಶ್ರೀ ವಾದಿರಾಜರ ಸುವರ್ಣ ಪಾದುಕೆ",
    sanskrit: "श्री वादिराज सुवर्णपादुका",
    tagline: "The golden sandals - a divine blessing from the heavenly plane",
    taglineKn: "ಸ್ವರ್ಗಲೋಕದಿಂದ ಬಂದ ದೈವಿಕ ಅನುಗ್ರಹ - ಸುವರ್ಣ ಪಾದುಕೆಗಳು",
    image: OFFICIAL.suvarnapaduka,
    isIdol: true,
    sizeClass: "max-h-[75%] max-w-[75%]",
    timing: "Worshipped with the icons of Mukhyaprana and Vadiraja",
    timingKn: "ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ವಾದಿರಾಜರ ಮೂರ್ತಿಗಳೊಂದಿಗೆ ಪೂಜೆ",
    intro:
      "The two golden sandals (Suvarnapaduka) of Vadiraja are also worshipped with due adoration. These sandals originally belonged to the divine world (heaven). God Indra and other gods worshipped them with regard and reverence as they symbolise moving stock samples or replicas of Vadiraja's gracious presence. Those golden sandals have been blessed to this mundane world by divinity for the welfare of mankind. After Vrindavanapravesha, Sri Vadiraja appeared in the godly plane with the same form and out of compassion blessed the sandals of his holy presence to disciples.",
    introKn:
      "ಶ್ರೀ ವಾದಿರಾಜರ ಎರಡು ಸುವರ್ಣ ಪಾದುಕೆಗಳನ್ನೂ ಶ್ರದ್ಧಾಭಕ್ತಿಯಿಂದ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ಈ ಪಾದುಕೆಗಳು ಮೂಲತಃ ಸ್ವರ್ಗಲೋಕಕ್ಕೆ ಸೇರಿದವು. ಇಂದ್ರಾದಿ ದೇವತೆಗಳು ಇವನ್ನು ವಾದಿರಾಜರ ಕರುಣಾಮಯ ಸಾನ್ನಿಧ್ಯದ ಸಂಚಾರಿ ಪ್ರತಿಬಿಂಬಗಳೆಂದು ಪೂಜಿಸಿ ಗೌರವಿಸುತ್ತಿದ್ದರು. ಮಾನವಕುಲದ ಶ್ರೇಯಸ್ಸಿಗಾಗಿ ದೈವಿಕ ಶಕ್ತಿಯು ಈ ಸುವರ್ಣ ಪಾದುಕೆಗಳನ್ನು ಈ ಲೋಕಕ್ಕೆ ಅನುಗ್ರಹಿಸಿದೆ. ವೃಂದಾವನ ಪ್ರವೇಶದ ನಂತರ ಶ್ರೀ ವಾದಿರಾಜರು ದೇವಲೋಕದಲ್ಲಿ ಅದೇ ಸ್ವರೂಪದಲ್ಲಿ ಪ್ರಕಟಗೊಂಡು ಕರುಣೆಯಿಂದ ತಮ್ಮ ಪವಿತ್ರ ಸಾನ್ನಿಧ್ಯದ ಪಾದುಕೆಗಳನ್ನು ಶಿಷ್ಯರಿಗೆ ಅನುಗ್ರಹಿಸಿದರು.",
    significance:
      "These golden sandals are worshipped daily along with the icons of Mukhyaprana and Sri Vadiraja with glorious adoration.",
    significanceKn:
      "ಈ ಸುವರ್ಣ ಪಾದುಕೆಗಳನ್ನು ಶ್ರೀ ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ಶ್ರೀ ವಾದಿರಾಜರ ಮೂರ್ತಿಗಳೊಂದಿಗೆ ದೈನಂದಿನ ವೈಭವಪೂರ್ಣವಾಗಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
  },
];
